<template>
  <!-- <v-layout>
      <h1>Fixed Cost #{{$route.params.id}}</h1>
  </v-layout>-->
  <v-layout pl-2 pt-2 pr-2 pb-2 justify-start row v-if="drivers.length > 0">
    <div style="width: 100%;">
      <div style="padding-left: 12px;">
        <v-flex shrink pb-3>
          <SimpleCard>
            <v-col>
              <v-sheet height="64">
                <v-toolbar flat color="white">
                  <v-btn outlined class="mr-4" color="grey darken-2" @click="setToday">Today</v-btn>
                  <v-btn fab text small color="grey darken-2" @click="prev">
                    <v-icon small>keyboard_arrow_left</v-icon>
                  </v-btn>
                  <v-btn fab text small color="grey darken-2" @click="next">
                    <v-icon small>keyboard_arrow_right</v-icon>
                  </v-btn>
                  <v-toolbar-title v-if="$refs.calendar">{{ $refs.calendar.title }}</v-toolbar-title>
                  <v-spacer></v-spacer>
                </v-toolbar>
              </v-sheet>
              <v-sheet height="700">
                <v-calendar
                  ref="calendar"
                  v-model="focus"
                  color="primary"
                  type="category"
                  category-show-all
                  :categories="categories"
                  :events="events"
                  :event-color="getEventColor"
                  @change="fetchEvents"
                  @click:event="showEvent"
                >
                  <template v-slot:category="{category}">
                    <v-flex pl-2>
                      <p
                        style="color: grey; font-size: 12px; "
                        v-html="formatDriverCategoryHead(category)"
                      ></p>
                    </v-flex>
                  </template>
                </v-calendar>
              </v-sheet>
            </v-col>
          </SimpleCard>
        </v-flex>
        <SimpleCard style="height: 30%;">
          <v-layout row wrap align-content-center justify-center>
            <v-flex v-if="loading" xs12 pa-2 class="text-xs-center">
              <v-progress-circular :size="48" :width="5" color="primary" indeterminate></v-progress-circular>
            </v-flex>
            <v-row align="center" justify="end">
              <v-icon :size="16">help</v-icon>
              <p style="font-size: 11px;">You can preassign a driver by clicking the driver cell.</p>
            </v-row>
            <BookingSummaryListCalendar
              v-if="!loading"
              style="width: 100%;"
              :bookings="bookings"
              :paginationProp="pagination"
              :rideTypes="rideTypes"
              @reload="getBookingsForPreassignment"
              @preassigned="preassigned"
            ></BookingSummaryListCalendar>
            <v-flex v-if="!loading" pt-2 xs9 class="text-xs-center pt-2">
              <v-pagination @input="changePage" v-model="pagination.page" :length="num_pages"></v-pagination>
            </v-flex>
          </v-layout>
        </SimpleCard>
      </div>
    </div>
    <v-menu
      v-model="selectedOpen"
      :activator="selectedElement"
      :close-on-content-click="false"
      offset-x
    >
      <v-card
        color="grey lighten-4"
        min-width="350px"
        flat
        v-if="eventForId(selectedEvent.name) != undefined"
      >
        <v-toolbar :color="selectedEvent.color" dark>
          <v-toolbar-title>Booking #{{selectedEvent.name}}</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <v-col style="padding: 0px !important;">
            <v-flex>
              <b>Pickup Time</b>
              {{eventForId(selectedEvent.name).pickup_time}}
            </v-flex>
            <v-flex>
              <b>PAX</b>
              {{ eventForId(selectedEvent.name).num_people }}
            </v-flex>
            <v-flex>
              <span>
                <b>Pickup</b>
                {{ eventForId(selectedEvent.name).pickup_location }}
              </span>
            </v-flex>
            <v-flex>
              <ViasForBooking :large="true" :booking="eventForId(selectedEvent.name)" />
            </v-flex>
            <v-flex>
              <span>
                <b>Destination</b>
                <p v-html="destinationForBooking(eventForId(selectedEvent.name))"></p>
              </span>
            </v-flex>
            <v-flex>
              <div>
                <b>Customer</b>
                <span>
                  <a
                    href="#"
                    v-on:click.stop="goToUser(eventForId(selectedEvent.name).user_id)"
                  >{{ eventForId(selectedEvent.name).user_name }}</a>
                  <br />
                  <p
                    v-if="eventForId(selectedEvent.name).business_customer_name"
                  >{{eventForId(selectedEvent.name).business_customer_name}}</p>
                  <p
                    v-if="eventForId(selectedEvent.name).ref_num"
                  >{{eventForId(selectedEvent.name).ref_num}}</p>
                </span>
                <a
                  style="font-size: 12px;"
                  :href="'tel:' + formatNumber(driverForId(eventForId(selectedEvent.name).preassigned_driver_id).contact_number)"
                >Call Driver</a>
                <br />
                <a
                  v-if="eventForId(selectedEvent.name).contact_number != null"
                  style="font-size: 12px;"
                  :href="'tel:' + formatNumber(eventForId(selectedEvent.name).contact_number)"
                >Call Customer</a>
                <br />
                <a
                  v-if="eventForId(selectedEvent.name).business_customer_number != null"
                  style="font-size: 12px;"
                  :href="'tel:' + formatNumber(eventForId(selectedEvent.name).business_customer_number)"
                >Call Lead Passenger</a>
              </div>
            </v-flex>
            <!-- <v-flex>{{(eventForId(selectedEvent.name).route_time/60).toFixed(2)}} mins</v-flex> -->
          </v-col>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="goToBooking(selectedEvent.name)" outlined color="primary">View/Edit</v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
    <v-dialog
      v-model="viewBookingDialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card style="background-color: #f4f5f9;">
        <v-toolbar dark color="secondary">
          <v-btn icon dark @click="closeViewBookingDialog">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>View/Edit Booking #{{currentBookingID + " - " + (bookingForm != null ? bookingForm.booking.state : "")}}</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-flex v-if="loadingEditBooking == true">
          <v-progress-linear indeterminate color="yellow darken-2"></v-progress-linear>
        </v-flex>
        <LargeBookForm
          :updateMode="true"
          v-if="viewBookingDialog == true"
          :bookingForm="bookingForm"
          @cancelledBooking="cancelledBooking"
        />
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import LargeBookForm from "@/components/booking/LargeBookForm.vue";
import { BookingForm } from "@/components/util/BookingForm.js";

import SimpleCard from "@/components/widget/SimpleCard.vue";
import BookingSummaryListCalendar from "@/components/booking/BookingSummaryListCalendar.vue";
import BookingSearchBox from "@/components/booking/BookingSearchBox.vue";
import ViasForBooking from "@/components/overwatch/ViasForBooking.vue";

import { replaceStart } from "@/components/util/PhoneNumbers.js";

import qs from "qs";
import axios from "axios";
axios.defaults.withCredentials = true;

import moment from "moment";

export default {
  name: "bookings",
  components: {
    SimpleCard,
    BookingSummaryListCalendar,
    BookingSearchBox,
    ViasForBooking,
    LargeBookForm,
  },
  data: function () {
    return {
      bookings: [],
      offset: 0,
      count: 20,
      query: {
        state: "booked",
        name: "",
        number: "",
        pickup: "",
        destination: "",
        before: "",
        after: "",
        paymentType: "all",
        bookingMethod: "all",
        refNum: "",
        bookingID: null,
        hideRepeatTrips: false,
      },
      loading: true,
      pagination: { page: 1 },
      num_pages: 0,
      rideTypes: [],
      events: [],
      focus: "",
      ries: [],
      drivers: [],
      preassignedBookings: [],
      selectedOpen: false,
      selectedEvent: {},
      selectedElement: null,
      currentBookingID: -1,
      viewBookingDialog: false,
      loadingEditBooking: false,
      bookingForm: null,
      min: null,
      max: null,
    };
  },
  mounted: async function () {
    if (this.$route.query.bookingID) {
      this.query.bookingID = this.$route.query.bookingID;
      this.query.before = "";
      this.query.state = "all";
    }

    if (this.$route.query.contact_number) {
      this.query.number = this.$route.query.contact_number;
      this.query.before = "";
      this.query.state = "all";
    }

    if (this.$route.query.name) {
      this.query.name = this.$route.query.name;
      this.query.before = "";
      this.query.state = "all";
    }

    this.getBookingsForPreassignment();
    this.getRideTypes();
    this.getDrivers();
  },
  methods: {
    formatNumber: function (number) {
      return replaceStart(number);
    },
    destinationForBooking: function (booking) {
      var destinations = "-";

      if (booking.destinations.length > 0) {
        return booking.destinations[0].description;
      }

      return destinations;
    },
    goToUser: function (id) {
      window.open(`/customer/view/${id}`, "_blank");
    },
    goToDriver: function (id) {
      window.open(`/driver/view/${id}`, "_blank");
    },
    eventForId(id) {
      console.log("LOOKING FOR " + id);
      return this.preassignedBookings.find(function (b) {
        return b.id.toString() == id;
      });
    },
    showEvent({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event;
        this.selectedElement = nativeEvent.target;
        setTimeout(() => (this.selectedOpen = true), 100);
      };

      if (this.selectedOpen) {
        this.selectedOpen = false;
        setTimeout(open, 100);
      } else {
        open();
      }

      nativeEvent.stopPropagation();
    },
    preassigned(bookingSummary) {
      var index = this.bookings.indexOf(bookingSummary);

      if (index > -1) {
        this.bookings.splice(index, 1);
      }

      this.preassignedBookings.push(bookingSummary);
      this.renderPreassignedBookings();
    },
    cancelledBooking() {
      console.log("Booking cancelled");

      var vm = this;
      this.bookings.forEach(function (b) {
        if (b.id == vm.currentBookingID) {
          b.state = "cancelled";
        }
      });
      this.cancelEditBooking();
    },
    driverForId(driverId) {
      var driver = this.drivers.find(function (d) {
        return d.id == driverId;
      });

      return driver;
    },
    formatDriverCategoryHead(driverId) {
      var driver = this.drivers.find(function (d) {
        return d.id == driverId;
      });

      console.log(driverId);
      console.log(driver);

      if (driver == null) {
        console.log("Driver not in list of drivers with callsign");
        return "-1";
      }

      return (
        "<b>" + driver.callsign + "</b>&nbsp;" + driver.name.substring(0, 15)
      );
    },
    getEventColor(event) {
      return event.color;
    },
    setToday() {
      this.focus = "";
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    async fetchEvents({ start, end }) {
      console.log("Fetching events");

      if (start != null) {
        this.min = start.date;
      }

      if (end != null) {
        this.max = end.date;
      }

      try {
        var url;

        // if (this.query.bookingID == null || this.query.bookingID == "") {
        url = `${
          this.$store.state.apiUrl
        }/bookingTimeline/preassigned?offset=0&count=2000&state=all&name=${
          this.query.name
        }&number=${this.query.number.trim()}&paymentType=${
          this.query.paymentType
        }&bookingMethod=${this.query.bookingMethod}&before=${this.max}&after=${
          this.min
        }&hideRepeatTrips=false`;

        let response = await axios.get(url, {
          params: {},
        });

        var bookings = response.data.bookings;
        this.preassignedBookings = response.data.bookings;

        console.log("Got preassigned bookings");
      } catch (error) {
        console.log("Failed to get bookings " + error);
      }

      this.renderPreassignedBookings();
    },
    renderPreassignedBookings() {
      const events = [];

      for (var i = 0; i < this.preassignedBookings.length; i++) {
        var booking = this.preassignedBookings[i];

        var color;

        if (booking.state == "cancelled") {
          color = "grey";
        } else if (booking.state == "completed") {
          color = "white";
        } else if (booking.state == "booked") {
          color = "blue";
        } else if (booking.state == "accepted") {
          color = "green";
        }

        console.log(booking);

        const first = moment(booking.pickup_time, "DD/MM/YYYY HH:mm").toDate();

        var second;

        if (booking.route_time != null) {
          second = moment(booking.pickup_time, "DD/MM/YYYY HH:mm")
            .add(booking.route_time, "seconds")
            .toDate();
        } else {
          second = moment(booking.pickup_time, "DD/MM/YYYY HH:mm").toDate();
        }

        events.push({
          name: booking.id.toString(),
          start: first,
          end: second,
          color: color,
          timed: true,
          category: booking.preassigned_driver_id.toString(),
        });
      }

      this.events = events;

      this.$refs.calendar.checkChange();

      console.log("Events");
      console.log(this.events);
    },
    rnd(a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a;
    },
    search: function () {
      this.pagination.page = 1;
      this.getBookingsForPreassignment();
    },
    clear: function () {
      this.query = {
        state: "all",
        name: "",
        number: "",
        pickup: "",
        destination: "",
        before: "",
        after: "",
        paymentType: "all",
        bookingMethod: "all",
        refNum: "",
        bookingID: null,
      };
    },
    changePage: function (page) {
      this.pagination.page = page;
      console.log(page);
      this.getBookingsForPreassignment();
    },
    getBookingsForPreassignment: async function () {
      this.loading = true;

      try {
        var url;

        // if (this.query.bookingID == null || this.query.bookingID == "") {
        url = `${
          this.$store.state.apiUrl
        }/bookingTimeline/requiresPreassignment?offset=${
          this.count * (this.pagination.page - 1)
        }&count=${this.count}&state=${this.query.state}&name=${
          this.query.name
        }&number=${this.query.number.trim()}&paymentType=${
          this.query.paymentType
        }&bookingMethod=${this.query.bookingMethod}&before=${
          this.query.before
        }&after=${this.query.after}&hideRepeatTrips=${
          this.query.hideRepeatTrips
        }`;

        if (this.query.refNum != null && this.query.refNum != "") {
          url += `&refNum=${this.query.refNum}`;
        }

        if (this.query.pickup != null && this.query.pickup != "") {
          url += `&pickup=${this.query.pickup}`;
        }

        if (this.query.destination != null && this.query.destination != "") {
          url += `&destination=${this.query.destination}`;
        }

        if (this.query.bookingID != null && this.query.bookingID != "") {
          url += `&bookingID=${this.query.bookingID}`;
        }
        // }

        let response = await axios.get(url, {
          params: {},
        });

        var bookings = response.data.bookings;

        this.bookings = bookings;

        this.pagination.page = response.data.pages.page;
        this.num_pages = response.data.pages.num_pages;

        console.log(response.data.num_pages);

        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log("Failed to get bookings " + error);
      }
    },
    getRideTypes: async function () {
      try {
        var url = `${this.$store.state.apiUrl}/ride_types/all`;

        let response = await axios.get(url, {
          params: {},
        });

        this.rideTypes = response.data;

        this.getRepeatService();

        console.log("got ride types");
      } catch (error) {
        this.loading = false;
        console.log("Failed to get ride types " + error);
      }
    },
    getDrivers: async function () {
      try {
        var url = `${this.$store.state.apiUrl}/bookingTimeline/timelineDrivers`;

        let response = await axios.get(url, {
          params: {},
        });

        this.drivers = response.data.drivers;

        var self = this;
        setTimeout(function () {
          self.$refs.calendar.checkChange();
        }, 500);

        this.categories = this.drivers.map(function (d) {
          return d.id.toString();
        });
      } catch (error) {
        this.loading = false;
        console.log("Failed to get ride types " + error);
      }
    },
    failed: function (data) {
      alert("Request Failed with error: " + data.message);
    },

    async getBookingForEdit(bookingID) {
      this.loadingEditBooking = true;

      try {
        var url = `${this.$store.state.apiUrl}/booking/${bookingID}/get`;

        let response = await axios.get(url, {
          params: {},
        });

        this.loadingEditBooking = false;

        if (response.error == null || response.error == "no_error") {
          return response.data;
        } else {
          return response.data.error;
        }
      } catch (error) {
        this.loadingEditBooking = false;

        console.log("Failed to get booking " + error);
        return "Unknown Error";
      }
    },
    goToBooking: function (id) {
      this.cancelEditBooking(false);

      this.currentBookingID = id;

      var vm = this;

      vm.$nextTick(async function () {
        this.viewBookingDialog = true;

        var booking = await vm.getBookingForEdit(id);

        console.log("booking");
        console.log(booking);

        if (typeof booking === "string") {
          console.log("Error for edit booking");
          this.editBookingError = booking;
          alert(this.editBookingError);
        } else {
          var bookingUser = BookingForm.jsonToBookingFormBookingUser(booking);

          this.bookingForm = new BookingForm(
            this.rideTypes,
            bookingUser,
            this.$store
          );
        }

        this.loadingEditBooking = false;
      });
    },
    cancelEditBooking: function (reload) {
      console.log("Hiding booking dialog");
      this.bookingForm = null;

      this.loadingEditBooking = true;
      this.editBookingError = null;
      this.viewBookingDialog = false;

      this.fetchEvents({ start: null, end: null });
    },
    closeViewBookingDialog: function () {
      console.log("Closing view booking dialog");
      this.cancelEditBooking();
    },
  },
};
</script>
